// eslint-disable-next-line

const SET_AXIOS_ERROR = (state, error) => {
  state.axiosError = error;
  state.showErrorSummary = true;
};

const RESET_AXIOS_ERROR = (state) => {
  state.axiosError = undefined;
};
const SET_SUBMIT_ROUTE_NAME = (state, name) => {
  state.submitRouteName = name;
};

const SET_SUCCESS_RESPONSE = (state) => {
  state.showSuccessMessage = true;
  setTimeout(() => {
    state.showSuccessMessage = false;
  }, 5000);
};
const CLEAR_ERRORS_BY_NAME = (state, name) => {
  if (state.axiosError?.success) return;
  const clone = { ...state.axiosError };
  const errors = clone.response?.data?.error?.errors;
  if (!errors || !(name in errors)) return;
  delete errors[name];
  state.axiosError = clone;
};

const SET_VALIDATION_RULES = (state, rules) => {
  state.validationRules = rules;
};

const SET_VALIDATION_MESSAGES = (state, messages) => {
  state.validationMessages = messages;
};

const SET_SUCCESS_MESSAGE = (state, message) => {
  state.successMessage = message;
};
export default {
  SET_AXIOS_ERROR,
  SET_SUCCESS_RESPONSE,
  SET_SUBMIT_ROUTE_NAME,
  SET_VALIDATION_RULES,
  SET_VALIDATION_MESSAGES,
  SET_SUCCESS_MESSAGE,
  CLEAR_ERRORS_BY_NAME,
  RESET_AXIOS_ERROR,
};
